
import { debounce } from "lodash";
import { defineComponent } from "vue";
import { Action, ElMessage, ElMessageBox } from "element-plus";
import { Filter } from "@/types/filter.type";
import { Container } from "@/types/container.type";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { ElRowClassNameParams } from "@/types/element.type";
import PageHeaderComponent from "../../components/PageHeader.component.vue";
import SamplingPointFormComponent from "@/components/samplingPoints/SamplingPointForm.component.vue";
import { getSamplingPointsNoRelations } from "@/service/samplingpoint.service";

export default defineComponent({
  components: { PageHeaderComponent },

  data() {
    return {
      entities: [] as SamplingPoint[],
      containers: [] as Container[],
      currentPage: 0 as number,
      rowPerPage: 10 as number,
      totalRows: 0 as number,
      query: "" as string,
      showEntityForm: false,
      showEntityInfo: false,
      samplingPointSelected: undefined as undefined | SamplingPoint,
    };
  },
  created() {
    // - apply delay
    this.search = debounce(this.refreshEntities, 300);
  },
  mounted() {
    this.currentPage = 1;
    this.refreshEntities();
  },
  methods: {
    search(): void {
      this.refreshEntities();
    },
    /**
     * table row css class name
     * @param params
     * @return css class name
     */
    tableRowClassName(params: ElRowClassNameParams<SamplingPoint>): string {
      return params.row && params.row.status ? "" : "disable-row";
    },

    /**
     * set page
     * @param page
     */
    changePaginationSize(size: number): void {
      this.rowPerPage = size;
      this.refreshEntities();
    },

    /**
     * change page
     * @param {number} page
     */
    changePaginationPage(page: number): void {
      this.currentPage = page;
      this.refreshEntities();
    },

    /**
     * refresh samplingPoint item from list items
     * @param item
     */
    async refreshEntities(item: SamplingPoint | undefined = undefined) {
      let index = -1;
      if (this.entities && item) {
        index = this.entities.findIndex((i) => i.id === item.id);
      }
      if (index !== -1 && item) {
        this.entities[index] = item;
      } else {
        const filter: Filter = {};
        if (this.query) {
          filter.multi = this.query;
        }
        const pagination = await getSamplingPointsNoRelations(
          this.currentPage,
          this.rowPerPage,
          filter
        );
        this.totalRows = pagination.totalRows;
        this.entities = pagination.data;
      }
    },

    goToImageLabel(samplingPoint: SamplingPoint) {
      this.$router.push({
        path: `${this.$route.path}/classificationImage`,
        query: {
          ...this.$route.query,
          samplingPoint: samplingPoint.id,
        },
      });

      // this.$router.push(`${this.$route.path}/classificationImage/${samplingPoint.id}`);
    },

    goToCreateData(samplingPoint: SamplingPoint) {
      this.$router.push({
        path: `${this.$route.path}/samplingPointConfig`,
        query: {
          ...this.$route.query,
          samplingPoint: samplingPoint.id,
        },
      });
    },

    goToTraingDataImage(samplingPoint: SamplingPoint) {
      this.$router.push({
        path: `${this.$route.path}/FQConfig`,
        query: {
          ...this.$route.query,
          samplingPoint: samplingPoint.id,
        },
      });
    },
  },
});
